import { payment } from 'routes/Checkout/checkoutPaymentReducers'
import { checkoutReducers } from 'routes/Checkout/checkoutReducers'
import { checkoutUrgencyReducers } from 'routes/Checkout/checkoutUrgencyReducers'
import { signupReducers } from 'routes/Signup/signupReducers'

import { accountReducers } from './account'
import { appBanner } from './appBanner'
import auth from './auth'
import basket from './basket'
import { boxSummaryReducers } from './boxSummary'
import { deliveryDetailsReducer } from './deliveryDetails'
import { feedback } from './feedback'
import { filtersReducers } from './filters'
import { getHelp } from './getHelp'
import { loggingManager } from './loggingmanager'
import { loginReducers } from './login'
import { menuReducers } from './menu'
import { boxesReducers } from './menu-boxes/boxes'
import { menuCollectionsReducers } from './menu-collections/menuCollections'
import { menuGroupsReducers } from './menu-groups/menuGroups'
import { menuV3Reducers } from './menu-metadata/metadata'
import { menuRecipesReducers } from './menu-recipes/recipes'
import { onScreenRecoveryReducers } from './onScreenRecovery'
import { persistReducers } from './persist'
import { productsReducers } from './products'
import { promosReducers } from './promos'
import { recipesReducers } from './recipes'
import { redirectReducers } from './redirect'
import { requestReducers } from './request'
import { ribbonReducer } from './ribbonReducer'
import { serverErrorReducers } from './serverError'
import status from './status'
import subscription from './subscription'
import { tempReducers } from './temp'
import { trackingReducers } from './tracking'
import { tutorial } from './tutorial'
import user from './user'

// Order items alphabetically
export const reducers = {
  ...appBanner,
  ...accountReducers,
  ...auth,
  ...basket,
  ...boxSummaryReducers,
  ...boxesReducers,
  ...checkoutReducers,
  ...checkoutUrgencyReducers,
  ...deliveryDetailsReducer,
  ...feedback,
  ...filtersReducers,
  getHelp,
  ...loginReducers,
  loggingManager,
  ...menuReducers,
  ...menuV3Reducers,
  ...menuCollectionsReducers,
  ...menuGroupsReducers,
  ...menuRecipesReducers,
  ...onScreenRecoveryReducers,
  payment,
  ...persistReducers,
  ...productsReducers,
  ...promosReducers,
  ...recipesReducers,
  ...redirectReducers,
  ...serverErrorReducers,
  ...signupReducers,
  ...status,
  ...subscription,
  ...tempReducers,
  ...trackingReducers,
  ...tutorial,
  ...user,
  ...requestReducers,
  ...ribbonReducer,
}
